import { useEffect, useState } from "react";

// Anuncios de la franja inferior (ver /publicidad en frontend/public). Tres huecos que rotan: cada
// pocos segundos todos avanzan una posición, con un fundido, para que se vayan viendo todos.
const ANUNCIOS = ["fibrabox", "reservatupista", "modularbox", "puntopadel", "turegalito"].map((n) => `/publicidad/${n}.jpg`);
const SEGUNDOS_POR_ROTACION = 8;

export function Publicidad() {
  const [inicio, setInicio] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let cambio: ReturnType<typeof setTimeout>;
    const t = setInterval(() => {
      setVisible(false);
      cambio = setTimeout(() => {
        setInicio((i) => (i + 1) % ANUNCIOS.length);
        setVisible(true);
      }, 600);
    }, SEGUNDOS_POR_ROTACION * 1000);
    return () => {
      clearInterval(t);
      clearTimeout(cambio);
    };
  }, []);

  return (
    <div className="mc-publicidad">
      {[0, 1, 2].map((hueco) => (
        <div key={hueco} className="mc-publicidad-hueco">
          <img src={ANUNCIOS[(inicio + hueco) % ANUNCIOS.length]} alt="" style={{ opacity: visible ? 1 : 0 }} draggable={false} />
        </div>
      ))}
    </div>
  );
}
